import React from "react";
import { Context } from "../contexts/context";

export function useContextMenuRequest() {
	const { contextMenuRequest } = React.useContext(Context);
	return contextMenuRequest;
}
